import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Typography } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { login, isLoggedIn } from "../services/authService";
import styles from "./Login.module.css";
import { routes } from "../routes";
import { doctorsService } from "../services/doctorsService";
import { adminUserService } from "../services/adminUserService";
import { useAuth } from "../contexts/authContext";
import { useLoaderProvider } from "../contexts/LoaderContext";

const { Text } = Typography;

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { loginContext } = useAuth();
  const { showLoader, hideLoader } = useLoaderProvider();

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (isLoggedIn()) {
        try {
          showLoader("Recupero informazioni account...");
          await adminUserService.getAccount();
          const doctor = await doctorsService.getLoggedDoctor();
          loginContext(doctor);
          navigate(`${routes.DASHBOARD}`);
        } catch (error) {
          console.error(
            "Errore nel recupero delle informazioni dell'account:",
            error,
          );
        } finally {
          hideLoader();
        }
      }
    };

    checkLoginStatus();
  }, [hideLoader, loginContext, navigate, showLoader]);

  const handleLogin = () => {
    login();
  };

  return (
    <div className={styles.loginContainer}>
      <Card className={styles.loginCard} title="Accedi a ICEP Platform">
        <p style={{ textAlign: "center" }}>Benvenuto nella piattaforma</p>
        <div style={{ textAlign: "center" }}>
          <Text strong style={{ fontSize: "1.5rem" }}>
            ICEP Platform
          </Text>
        </div>
        <Button type="primary" icon={<LoginOutlined />} onClick={handleLogin}>
          Accedi
        </Button>
      </Card>
    </div>
  );
};

export default LoginPage;
